import types, { ActionCreators } from './types';

const productGroupsOK: ActionCreators['ProductGroupsOK'] = (productGroups) => ({
  type: types.PRODUCT_GROUPS_OK,
  productGroups,
});

export default {
  productGroupsOK,
};
